import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export const LoadingIcon = ({ className }: { className?: string }) => {
  return <Loader2 className={cn('text-gray-400 h-6 w-6 animate-spin', className)} />;
};
